import React, { useState, useEffect } from "react";
import { Draggable } from "react-beautiful-dnd";
import PhaseUpdate from "../PhaseUpdate";
import PhaseDelete from "../PhaseDelete";
import StatusCreate from "../StatusCreate";
import StatusDelete from "../StatusDelete";
import StatusUpdate from "../StatusUpdate";
import { Table } from "react-bootstrap";
import { setAccentColor } from "utils/EntityTagUtils";
import EmptyStateHandler from "components/ui/EmptyStateHandler";
import RequiredAsterisk from "components/ui/RequiredAsterisk";

import "./PhasesFields.scss";

const PhasesFields = ({
  phase,
  index,
  onPhasesUpdated,
  facilities,
  statuses,
}) => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [isCreateButtonDeleted, setIsCreateButtonDeleted] = useState(false);

  const handleRowClick = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  useEffect(() => {
    if (statuses.length === 5) {
      setIsCreateButtonDeleted(true);
    }
  }, [statuses]);

  return (
    <Draggable key={phase?.metaId} draggableId={phase?.metaId} index={index}>
      {(provided) => (
        <>
          <tr ref={provided.innerRef} {...provided.draggableProps}>
            <td {...provided.dragHandleProps}>
              <span translate="no" className="material-symbols-outlined md-16">
                drag_indicator
              </span>
            </td>
            <td
              className="cursor-pointer"
              onClick={() => handleRowClick(phase?.metaId)}
            >
              {selectedRow === phase?.metaId ? (
                <span className="material-symbols-outlined md-20 text-muted">
                  expand_less
                </span>
              ) : (
                <span className="material-symbols-outlined md-20 text-muted">
                  expand_more
                </span>
              )}
            </td>
            <td>{phase?.label}</td>
            <td>
              <StatusCreate
                phase={phase}
                existingStatuses={statuses}
                onStatusCreated={onPhasesUpdated}
                isCreateButtonDeleted={isCreateButtonDeleted}
              />
              <PhaseUpdate phase={phase} onPhaseUpdated={onPhasesUpdated} />
              <PhaseDelete
                phase={phase}
                onPhaseDeleted={onPhasesUpdated}
                facilities={facilities}
              />
            </td>
          </tr>
          {selectedRow === phase?.metaId && (
            <tr className="tableClass">
              <td colSpan={12}>
                <Table size="sm" className="small">
                  <thead>
                    <tr>
                      <th className="col-6">Status Name</th>
                      <th className="col-4">Color</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!statuses || !statuses.length ? (
                      <tr>
                        <td colSpan="7">
                          <EmptyStateHandler
                            title="No statuses found"
                            description="There are currently no statuses to show"
                          />
                        </td>
                      </tr>
                    ) : (
                      statuses.map((status) => (
                        <tr key={status?.metaId}>
                          <td>{status?.label}</td>
                          <td>
                            <small
                              className="px-2 py-1"
                              style={{
                                backgroundColor: status?.color || "#C1C1C1",
                                color: setAccentColor(status?.color),
                              }}
                            >
                              {status?.color || "#C1C1C1"}
                            </small>
                          </td>
                          <td>
                            <StatusUpdate
                              status={status}
                              existingStatuses={statuses}
                              onStatusUpdated={onPhasesUpdated}
                            />
                            <StatusDelete
                              status={status}
                              onStatusDeleted={onPhasesUpdated}
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
                <div className="text-muted mb-2">
                  <small>
                    <RequiredAsterisk />
                    Maximum 5 Statuses allowed
                  </small>
                </div>
              </td>
            </tr>
          )}
        </>
      )}
    </Draggable>
  );
};

export default PhasesFields;
